import axios from "../api/axiosinstance";

const MeetingBookingApi={

    getUser:(slug)=>

        axios.get(`/users/public/${slug}`),

    getSlots:(slug,date)=>

        axios.get(

            `/meeting-booking/slots?slug=${slug}&date=${date}`

        ),

    book:(payload)=>

        axios.post(

            "/meeting-booking/book",

            payload

        ),

};

export default MeetingBookingApi;